import request from '../helpers/request';

const changeRequestNoteAvailability = async (noteId, availableForClient) => {
  return await request.put(
    `/Request/change_note_availability/${noteId}`,
    availableForClient + '',
    'Не удалось изменить видимость комментария для собственника',
    { result: 'Error' }
  );
};

export default changeRequestNoteAvailability;
